import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadGenehmigungDefinitionHistoryListStatus: 'idle',
    loadGenehmigungDefinitionHistoryListError: undefined as any,
    loadGenehmigungDefinitionHistoryListLastArgs: undefined as any,
    loadGenehmigungDefinitionHistoryStatus: 'idle',
    loadGenehmigungDefinitionHistoryError: undefined as any,
    saveGenehmigungDefinitionHistoryStatus: 'idle',
    saveGenehmigungDefinitionHistoryError: undefined as any,
    deleteGenehmigungDefinitionHistoryStatus: 'idle',
    deleteGenehmigungDefinitionHistoryError: undefined as any,

    genehmigungDefinitionHistoryList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadGenehmigungDefinitionHistoryList = createAsyncThunk('auftragGenehmigungDefinitionHistorySlice/loadGenehmigungDefinitionHistoryList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragGenehmigungDefinitionHistorySlice.loadGenehmigungDefinitionHistoryListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisgenehmdefhist/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadGenehmigungDefinitionHistoryListStatus } = getState().auftragGenehmigungDefinitionHistorySlice
        return loadGenehmigungDefinitionHistoryListStatus !== 'pending'
    }
})

export const loadGenehmigungDefinitionHistory = createAsyncThunk('auftragGenehmigungDefinitionHistorySlice/loadGenehmigungDefinitionHistory', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisgenehmdefhist/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadGenehmigungDefinitionHistoryStatus } = getState().auftragGenehmigungDefinitionHistorySlice
        return loadGenehmigungDefinitionHistoryStatus !== 'pending'
    }
})

export const saveGenehmigungDefinitionHistory = createAsyncThunk('auftragGenehmigungDefinitionHistorySlice/saveGenehmigungDefinitionHistory', async ({ genehmigungDefinitionHistory }: any, { rejectWithValue }: any) => {
    let promises = []
    if (genehmigungDefinitionHistory?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurisgenehmdefhist/${ genehmigungDefinitionHistory?.HDR_ID }/`,
            prepareData(genehmigungDefinitionHistory),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurisgenehmdefhist/`,
            prepareData(genehmigungDefinitionHistory),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveGenehmigungDefinitionHistoryStatus } = getState().auftragGenehmigungDefinitionHistorySlice
        return saveGenehmigungDefinitionHistoryStatus !== 'pending'
    }
})

export const deleteGenehmigungDefinitionHistory = createAsyncThunk('auftragGenehmigungDefinitionHistorySlice/deleteGenehmigungDefinitionHistory', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurisgenehmdefhist/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteGenehmigungDefinitionHistoryStatus } = getState().auftragGenehmigungDefinitionHistorySlice
        return deleteGenehmigungDefinitionHistoryStatus !== 'pending'
    }
})

const GenehmigungDefinitionHistorySlice = createSlice({
    name: 'auftragGenehmigungDefinitionHistorySlice',
    initialState,
    reducers: {
        resetloadGenehmigungDefinitionHistoryListError: (state) => {
            state.loadGenehmigungDefinitionHistoryListError = undefined
        },
        resetloadGenehmigungDefinitionHistory: (state) => {
            state.formItem = undefined
            state.loadGenehmigungDefinitionHistoryError = undefined
        },
        resetloadGenehmigungDefinitionHistoryError: (state) => {
            state.loadGenehmigungDefinitionHistoryError = undefined
        },
        resetsaveGenehmigungDefinitionHistory: (state) => {
            state.formItem = undefined
            state.saveGenehmigungDefinitionHistoryError = undefined
        },
        resetsaveGenehmigungDefinitionHistoryError: (state) => {
            state.saveGenehmigungDefinitionHistoryError = undefined
        },
        resetdeleteGenehmigungDefinitionHistoryError: (state) => {
            state.deleteGenehmigungDefinitionHistoryError = undefined
        },
        removeFromGenehmigungDefinitionHistoryListById: (state, action) => {
            state.genehmigungDefinitionHistoryList = state.genehmigungDefinitionHistoryList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromGenehmigungDefinitionHistoryListByIds: (state, action) => {
            state.genehmigungDefinitionHistoryList = state.genehmigungDefinitionHistoryList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.genehmigungDefinitionHistoryList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadGenehmigungDefinitionHistoryListStatus = 'preloaded'
            state.loadGenehmigungDefinitionHistoryListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.genehmigungDefinitionHistoryList = []
            state.loadGenehmigungDefinitionHistoryListStatus = 'idle'
            state.loadGenehmigungDefinitionHistoryListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadGenehmigungDefinitionHistoryList.pending, (state) => {
            state.loadGenehmigungDefinitionHistoryListStatus = 'pending'
            state.loadGenehmigungDefinitionHistoryListError = undefined
        })
        builder.addCase(loadGenehmigungDefinitionHistoryList.fulfilled, (state, action) => {
            state.loadGenehmigungDefinitionHistoryListStatus = 'idle'

            if (!action.payload) { return }

            state.loadGenehmigungDefinitionHistoryListLastArgs = action.payload.args

            {
                state.genehmigungDefinitionHistoryList = action.payload.data

            }
        })
        builder.addCase(loadGenehmigungDefinitionHistoryList.rejected, (state, action) => {
            state.loadGenehmigungDefinitionHistoryListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadGenehmigungDefinitionHistoryListError = action.error.message
            } else {
                state.loadGenehmigungDefinitionHistoryListError = action.payload
            }
        })

        builder.addCase(loadGenehmigungDefinitionHistory.pending, (state) => {
            state.loadGenehmigungDefinitionHistoryStatus = 'pending'
            state.loadGenehmigungDefinitionHistoryError = undefined
        })
        builder.addCase(loadGenehmigungDefinitionHistory.fulfilled, (state, action) => {
            state.loadGenehmigungDefinitionHistoryStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.genehmigungDefinitionHistoryList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.genehmigungDefinitionHistoryList.push(newItem) }
                else { state.genehmigungDefinitionHistoryList[i] = { ...state.genehmigungDefinitionHistoryList[i], ...newItem } }
            }
        })
        builder.addCase(loadGenehmigungDefinitionHistory.rejected, (state, action) => {
            state.loadGenehmigungDefinitionHistoryStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadGenehmigungDefinitionHistoryError = action.error.message
            } else {
                state.loadGenehmigungDefinitionHistoryError = action.payload
            }
        })

        builder.addCase(saveGenehmigungDefinitionHistory.pending, (state) => {
            state.saveGenehmigungDefinitionHistoryStatus = 'pending'
            state.saveGenehmigungDefinitionHistoryError = undefined
        })
        builder.addCase(saveGenehmigungDefinitionHistory.fulfilled, (state, action) => {
            state.saveGenehmigungDefinitionHistoryStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.genehmigungDefinitionHistoryList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.genehmigungDefinitionHistoryList.push(newItem) }
                else { state.genehmigungDefinitionHistoryList[i] = { ...state.genehmigungDefinitionHistoryList[i], ...newItem } }
            }
        })
        builder.addCase(saveGenehmigungDefinitionHistory.rejected, (state, action) => {
            state.saveGenehmigungDefinitionHistoryStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveGenehmigungDefinitionHistoryError = action.error.message
            } else {
                state.saveGenehmigungDefinitionHistoryError = action.payload
            }
        })

        builder.addCase(deleteGenehmigungDefinitionHistory.pending, (state) => {
            state.deleteGenehmigungDefinitionHistoryStatus = 'pending'
            state.deleteGenehmigungDefinitionHistoryError = undefined
        })
        builder.addCase(deleteGenehmigungDefinitionHistory.fulfilled, (state, action) => {
            state.deleteGenehmigungDefinitionHistoryStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.genehmigungDefinitionHistoryList = state.genehmigungDefinitionHistoryList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.genehmigungDefinitionHistoryList = state.genehmigungDefinitionHistoryList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteGenehmigungDefinitionHistory.rejected, (state, action) => {
            state.deleteGenehmigungDefinitionHistoryStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteGenehmigungDefinitionHistoryError = action.error.message
            } else {
                state.deleteGenehmigungDefinitionHistoryError = action.payload
            }
        })

    }
})

export const {
    resetloadGenehmigungDefinitionHistoryListError,
    resetloadGenehmigungDefinitionHistory,
    resetloadGenehmigungDefinitionHistoryError,
    resetsaveGenehmigungDefinitionHistory,
    resetsaveGenehmigungDefinitionHistoryError,
    resetdeleteGenehmigungDefinitionHistoryError,
    removeFromGenehmigungDefinitionHistoryListById,
    removeFromGenehmigungDefinitionHistoryListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = GenehmigungDefinitionHistorySlice.actions
export default GenehmigungDefinitionHistorySlice.reducer
